import moment from 'moment'
import Header from 'components/Calendar/Header'
import Toolbar from 'components/Calendar/Toolbar'
import Event from 'components/Calendar/Event'

const date = moment()

export const views = ['month', 'week', 'day']
export const defaultView = 'week'
export const startAccessor = 'startDate'
export const endAccessor = 'endDate'
export const minTime = new Date(date.year(), date.month(), date.date(), 8, 0, 0)
export const maxTime = new Date(
  date.year(),
  date.month(),
  date.date(),
  22,
  0,
  0
)

export const messages = {
  allDay: '',
  previous: <i className="ion-ios-arrow-back" />,
  next: <i className="ion-ios-arrow-forward " />,
  today: 'Hoy',
  month: 'Mes',
  week: 'Semana',
  day: 'Día',
  agenda: 'Agenda',
  showMore: () => 'Mostrar más'
}

export const formats = {
  dayFormat: (date, culture, localizer) =>
    localizer.format(date, 'ddd D/M', culture),
  timeGutterFormat: 'h:mma'
}

export const components = {
  event: Event,
  toolbar: Toolbar,
  day: {
    header: Header
  },
  week: {
    header: Header
  },
  month: {
    header: Header
  }
}

export const reasons = [
  {
    id: 1,
    name: 'No había nadie en el domicilio',
    type: 'VALUATION_FAILURE'
  },
  {
    id: 2,
    name: 'Dirección incorrecta',
    type: 'VALUATION_FAILURE'
  },
  {
    id: 3,
    name: 'Ya no quisieron realizar la valuación.',
    type: 'VALUATION_FAILURE'
  },
  {
    id: 4,
    name: 'Re-agendo la valuación.',
    type: 'VALUATION_FAILURE'
  },

  {
    id: 5,
    name: 'Números de teléfono erróneos.',
    type: 'VALUATION_CANCELLED'
  },
  {
    id: 6,
    name: 'El usuario solo estaba probando la plataforma.',
    type: 'VALUATION_CANCELLED'
  },
  {
    id: 7,
    name: 'No se pudo contactar al usuario.',
    type: 'VALUATION_CANCELLED'
  },

  {
    id: 8,
    name: 'El interesado re-agendo',
    type: 'SHOW_FAILURE'
  },
  {
    id: 9,
    name: 'El propietario re-agendo',
    type: 'SHOW_FAILURE'
  },
  {
    id: 10,
    name: 'El propietario no dejo mostrar el inmueble.',
    type: 'SHOW_FAILURE'
  },
  {
    id: 11,
    name: 'No se presento el interesado.',
    type: 'SHOW_FAILURE'
  },

  {
    id: 12,
    name: 'El interesado cancelo.',
    type: 'SHOW_CANCELLED'
  },
  {
    id: 13,
    name: 'El propietario cancelo.',
    type: 'SHOW_CANCELLED'
  },
  {
    id: 14,
    name: 'El interesado re-agendo.',
    type: 'SHOW_CANCELLED'
  },
  {
    id: 15,
    name: 'El propietario re-agendo.',
    type: 'SHOW_CANCELLED'
  },
  {
    id: 16,
    name: 'No se presento el interesado.',
    type: 'SHOW_CANCELLED'
  },
  {
    id: 17,
    name: 'No se presento el propietario.',
    type: 'SHOW_CANCELLED'
  },
  {
    id: 18,
    name: 'El propietario no dejo mostrar la propiedad.',
    type: 'SHOW_CANCELLED'
  }
]

export const texts = {
  broker_valuation: {
    title: 'Cita de valuación',
    description: ''
  },
  valuation: {
    title: 'Cancelar cita de valuación',
    description: '¡Cuidado! está acción cancelará tu cita de valuación.'
  },
  show: {
    title: 'Cancelar cita de muestra',
    description: '¡Cuidado! está acción cancelará tu cita de muestra.'
  },
  custom_event: {
    title: 'Mi evento',
    description: ''
  }
}
